export const FILE_EXTENSIONS = {
  WORD_DOCUMENTS: ["doc", "docx"] as const,
  DOCUMENTS: ["pdf", "doc", "docx"] as const,
  IMAGES: ["jpg", "jpeg", "png", "gif", "webp"] as const,
  SPREADSHEETS: ["xls", "xlsx", "csv"] as const,
} as const;

export const FILE_MIME_TYPES = {
  WORD_DOCUMENTS: [
    "application/msword", // .doc files
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx files
  ] as const,
  DOCUMENTS: [
    "application/pdf", // .pdf files
    "application/msword", // .doc files
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx files
  ] as const,
  IMAGES: [
    "image/jpeg", // .jpg, .jpeg files
    "image/png", // .png files
    "image/gif", // .gif files
    "image/webp", // .webp files
  ] as const,
  SPREADSHEETS: [
    "application/vnd.ms-excel", // .xls files
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx files
    "text/csv", // .csv files
  ] as const,
} as const;

export const FILE_SIZES = {
  MB_1: 1 * 1024 * 1024,
  MB_5: 5 * 1024 * 1024,
  MB_10: 10 * 1024 * 1024,
  MB_25: 25 * 1024 * 1024,
  MB_50: 50 * 1024 * 1024,
  MB_100: 100 * 1024 * 1024,
} as const;

export const DEFAULT_ALLOWED_EXTENSIONS = FILE_EXTENSIONS.WORD_DOCUMENTS;
export const DEFAULT_MAX_FILE_SIZE = FILE_SIZES.MB_10; // 10MB

export const FILE_TYPE_DESCRIPTIONS = {
  WORD_DOCUMENTS: "Word documents (.doc, .docx)",
  ALL_DOCUMENTS: "Document templates (.doc, .docx, .pdf, .txt)",
  IMAGES: "Images (.jpg, .jpeg, .png, .gif, .webp)",
  SPREADSHEETS: "Spreadsheets (.xls, .xlsx, .csv)",
} as const;
